import { createAction } from '@reduxjs/toolkit';
export const DISCONNECT_CRM = 'DISCONNECT_CRM';
export const disconnectCrmAction = createAction(DISCONNECT_CRM);